'use strict'
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  CircularProgress
} from '@material-ui/core'

export default function PublishConfirmModal ({ open, onClose, onConfirm, scenarioName, diffData, publishing }) {
  const summary = diffData?.diff?.summary || {}
  const metricsDelta = diffData?.metricsDelta || null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Publish Scenario</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Publish <strong>{scenarioName || 'this scenario'}</strong> to live routing data?
        </Typography>
        <Box display="flex" flexWrap="wrap" style={{ gap: 8, marginTop: 16, marginBottom: 12 }}>
          <Chip size="small" label={`Moved: ${summary.movedCount || 0}`} />
          <Chip size="small" label={`VIP changes: ${summary.vipChangedCount || 0}`} />
          <Chip size="small" label={`Lock changes: ${summary.lockChangedCount || 0}`} />
        </Box>
        {metricsDelta && (
          <Box display="flex" flexWrap="wrap" style={{ gap: 8, marginBottom: 12 }}>
            <Chip
              size="small"
              label={`OT delta: ${Math.round(metricsDelta.totalOTMinutesDelta || 0)} min`}
              style={{
                backgroundColor: (metricsDelta.totalOTMinutesDelta || 0) <= 0 ? '#e8f5e9' : '#fce4ec',
                color: (metricsDelta.totalOTMinutesDelta || 0) <= 0 ? '#2e7d32' : '#c62828'
              }}
            />
            <Chip
              size="small"
              label={`Avg load delta: ${Math.round(metricsDelta.avgCrewLoadDelta || 0)} min`}
            />
            <Chip
              size="small"
              label={`Max load delta: ${Math.round(metricsDelta.maxCrewLoadDelta || 0)} min`}
            />
          </Box>
        )}
        <Typography variant="caption" color="textSecondary">
          This will apply all scenario overrides to live routing assignments. A CSV of changes will be downloaded automatically.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={publishing}>Cancel</Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={onConfirm}
          disabled={publishing}
          startIcon={publishing ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {publishing ? 'Publishing...' : 'Publish to Live'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
